import { render } from "./index.vue?vue&type=template&id=446840ab"
import script from "./breadcrumb.ts?vue&type=script&lang=js"
export * from "./breadcrumb.ts?vue&type=script&lang=js"

import "./breadcrumb.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script